import ReactDOM from 'react-dom/client';
import App from './App';
import initI18n from './i18n/config';
window.BACKEND_ENDPOINT = 'https://adventurespark01--main-endpoint-cpu.modal.run';
initI18n
  .then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
  });
